interface DataType {
   id: number;
   thumb: string;
   tag: string;
   date: string;
   title: string;
};

const inner_blog_data: DataType[] = [
   {
      id: 1,
      thumb: "/assets/img/blog/blog_post01.jpg",
      tag: "Marketing",
      date: "20 July, 2024",
      title: "How To Become idiculously Self-Aware In 20 Minutes"
   },
   {
      id: 2,
      thumb: "/assets/img/blog/blog_post02.jpg",
      tag: "Students",
      date: "20 July, 2024",
      title: "Get Started With UI Design With Tips To Speed"
   },
   {
      id: 3,
      thumb: "/assets/img/blog/blog_post03.jpg",
      tag: "Science",
      date: "20 July, 2024",
      title: "Make Your Own Expanding Contracting Content"
   },
   {
      id: 4,
      thumb: "/assets/img/blog/blog_post04.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 5,
      thumb: "/assets/img/blog/blog_post05.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 6,
      thumb: "/assets/img/blog/blog_post06.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 7,
      thumb: "/assets/img/blog/blog_post07.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 8,
      thumb: "/assets/img/blog/blog_post08.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 9,
      thumb: "/assets/img/blog/blog_post09.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 10,
      thumb: "/assets/img/blog/blog_post10.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 11,
      thumb: "/assets/img/blog/blog_post11.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 12,
      thumb: "/assets/img/blog/blog_post12.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 13,
      thumb: "/assets/img/blog/blog_post09.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 14,
      thumb: "/assets/img/blog/blog_post10.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 15,
      thumb: "/assets/img/blog/blog_post11.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 16,
      thumb: "/assets/img/blog/blog_post12.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 17,
      thumb: "/assets/img/blog/blog_post07.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
   {
      id: 18,
      thumb: "/assets/img/blog/blog_post08.jpg",
      tag: "Agency",
      date: "20 July, 2024",
      title: "What we are capable to usually discovered"
   },
];

export default inner_blog_data;